import UiCounter from "./UiCounter.vue"

export default [
  UiCounter,
]
